import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CONTACT, SITE } from "@/data/content";
import { useSound } from "@/lib/SoundContext";

export default function Contact() {
  const [ticked, setTicked] = useState({});
  const { play } = useSound();
  const count = Object.values(ticked).filter(Boolean).length;

  const toggle = (i) => {
    setTicked((t) => ({ ...t, [i]: !t[i] }));
    play("pop");
  };

  return (
    <div className="min-h-screen kitchen-bg pb-24" data-testid="contact-page">
      <div className="max-w-xl mx-auto px-4 pt-24">
        <Link to="/fridge" data-testid="back-to-fridge" className="font-hand font-bold text-ink/70 hover:text-ink text-lg">
          ← back to the fridge
        </Link>

        {/* contact info — first thing you see */}
        <motion.div
          className="mt-6 bg-[#FFF9C4] border-[4px] border-ink rounded-[8px] p-7 sm:p-8 -rotate-[0.5deg] shadow-[0_14px_0_rgba(43,35,32,0.15)]"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ type: "spring", stiffness: 120, damping: 14 }}
          data-testid="contact-reach-card"
        >
          <h1 className="font-display text-3xl sm:text-4xl leading-tight" data-testid="contact-heading">{CONTACT.reachHeading}</h1>
          <p className="font-hand text-ink/60 mt-1">{CONTACT.reachSub}</p>

          <div className="mt-6 grid gap-3">
            <a href={`mailto:${SITE.email}`} data-testid="contact-submit-button" className="btn-cartoon w-full justify-center text-lg">
              {CONTACT.cta}
            </a>
            <p className="font-hand text-sm text-ink/60 -mt-1 text-center">opens your email app · {SITE.email}</p>
            <a href={`tel:${SITE.phone.replace(/\s/g, "")}`} data-testid="contact-phone-button" className="btn-cartoon !bg-[#8FD0EE] w-full justify-center">
              CALL ME · {SITE.phone}
            </a>
            <a href={SITE.linkedin} target="_blank" rel="noreferrer" data-testid="contact-linkedin-link" className="btn-cartoon !bg-[#FF9E7D] w-full justify-center">
              {SITE.linkedinLabel} →
            </a>
          </div>
        </motion.div>

        {/* the grocery list */}
        <motion.div
          className="paper paper-ruled border-[4px] border-ink rounded-[8px] p-7 sm:p-10 mt-8 rotate-[0.5deg] shadow-[0_14px_0_rgba(43,35,32,0.15)]"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ type: "spring", stiffness: 120, damping: 14, delay: 0.12 }}
          data-testid="contact-list-card"
        >
          <div className="flex items-start justify-between gap-4">
            <h2 className="font-display text-2xl sm:text-3xl leading-tight">{CONTACT.heading}</h2>
            <span className="tape !text-xs -rotate-3 mt-2">stuck on the fridge</span>
          </div>
          <p className="font-hand text-ink/60 mt-1">{CONTACT.sub}</p>

          <div className="mt-6 space-y-1">
            {CONTACT.items.map((t, i) => (
              <div className="check-row" key={i}>
                <button
                  data-testid={`contact-checkbox-${i}`}
                  className="check-box"
                  onClick={() => toggle(i)}
                  aria-pressed={!!ticked[i]}
                >
                  {ticked[i] && (
                    <motion.span initial={{ scale: 0, rotate: -30 }} animate={{ scale: 1, rotate: 0 }} className="font-bold text-tomato">
                      ✕
                    </motion.span>
                  )}
                </button>
                <span className={ticked[i] ? "line-through opacity-45" : ""}>{t}</span>
              </div>
            ))}
          </div>

          <div className="mt-8 flex items-center justify-between font-hand font-bold text-xl border-t-[3px] border-dashed border-ink/40 pt-4">
            <span>TOTAL</span>
            <span>{count}/{CONTACT.items.length} — priceless</span>
          </div>
        </motion.div>

        <p className="font-hand text-center mt-8 text-lg text-ink/70">
          or just shout at the fridge — it listens. sometimes.
        </p>
      </div>
    </div>
  );
}
